<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("code") }}</label>
                  <b-form-input
                    :placeholder="$t('code')"
                    v-model="SchoolYear.code"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("shortname") }}</label>
                  <b-form-input
                    v-model="SchoolYear.shortname"
                    :placeholder="$t('shortname')"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div>
                  <label>{{ $t("fullname") }}</label>
                  <b-form-input
                    v-model="SchoolYear.fullname"
                    :placeholder="$t('fullname')"
                    type="text"
                  ></b-form-input>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div class="mt-2">
                  <label for>{{ $t("startdate") }}</label>
                  <div>
                    <date-picker
                      v-model="SchoolYear.startdate"
                      format="DD.MM.YYYY"
                      style="width:100%"
                      value-type="format"
                      :placeholder="$t('startdate')"
                    ></date-picker>
                  </div>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div class="mt-2">
                  <label for>{{ $t("enddate") }}</label>
                  <div>
                    <date-picker
                      v-model="SchoolYear.enddate"
                      format="DD.MM.YYYY"
                      style="width:100%"
                      value-type="format"
                      :placeholder="$t('enddate')"
                    ></date-picker>
                  </div>
                </div>
              </b-col>
              <b-col sm="12" md="4">
                <div class="mt-2">
                  <label for>{{ $t("state") }}</label>
                  <div>
                    <v-select
                      :options="StateList"
                      :reduce="(item) => item.id"
                      :placeholder="$t('ChooseBelow')"
                      label="name"
                      v-model="SchoolYear.stateid"
                    ></v-select>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-right">
                <b-button
                  @click="$router.push('/info/schoolyear')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
              <b-col style="text-align: right !important; " class="text-right">
                <b-button
                  @click="SaveData"
                  class="d-inline-block "
                  variant="success"
                  ><i class="dripicons-checkmark"></i>
                  {{ $t("save") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import SchoolYearService from "@/services/info/schoolyear.service";
import HelperService from "@/services/others/helper.service";
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
export default {
  components: { Multiselect, Layout, PageHeader, DatePicker, vSelect },
  data() {
    return {
      title: this.$t("SchoolYear"),
      braedcrumb: [
        {
          text: this.$t("Info"),
        },
        {
          text: this.$t("SchoolYear"),
          active: true,
        },
      ],
      items: [],
      validations: {
        SchoolYear: {
          Code: {
            required,
          },
          shortname: {
            required,
          },
          fullname: {
            required,
          },
          stateid: {
            required,
          },
        },
      },
      //   show: false,
      SchoolYear: {},
      autoClose: "",
      filter: {},
      StateList: [],
      lang: "ru",
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    HelperService.GetStateList().then((res) => {
      this.StateList = res.data;
    });
    SchoolYearService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.Account = res.data;
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
  },
  directives: {},
  methods: {
    SaveData() {
      SchoolYearService.Update(this.SchoolYear)
        .then((res) => {
          this.$notification(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: `schoolyear` });
        })
        .catch((err) => {
          this.$notification(this.$t(err.response.data.error), "danger");
        });
    },
  },
};
</script>

<style></style>
